import { get } from 'lodash';
import { SkApolloRequest } from '../../utils/apolloUtils';
import {
  FETCH_ADMISSIONS,
  FETCH_REGISTRATION_STATES,
  SEARCH_CHILD_IN_ADMISSIONS,
  FETCH_ADMISSIONS_WITH_FILTER,
  FETCH_REGISTRATIONS,
  FETCH_EXISTING_PARENT,
  FETCH_EXISTING_CHILD,
  FETCH_REGISTRATION_STATES_SUCCESS,
  FETCH_REGISTRATION_STATES_ERROR,
  FETCH_SUGGESTED_FEE_TIER,
  FETCH_ECDA_REGISTRATIONS,
  FETCH_ECDA_EXISTING_PARENT,
  FETCH_ECDA_EXISTING_CHILD,
} from './actionTypes';
import {
  SEARCH_ADMISSIONS,
  FIND_ALL_ADMISSION,
  GET_REGISTRATIONS,
  GET_EXISTING_PARENT,
  GET_EXISTING_CHILD,
  CREATE_REGISTRATION,
  EDIT_REGISTRATION,
  CANCEL_REGISTRATION,
  REINSTATE_CANCELLED_REGISTRATION,
  GET_REGISTRATIONS_FRONTEND_STATES,
  GET_EXISTING_PARENT_INFO,
  SUGGESTED_FEE_TIER,
  MERGE_PARENT_ACCOUNT,
  MERGE_REGISTRATION_PARENT_EMAIL,
  GET_ECDA_REGISTRATIONS,
  CREATE_REGISTRATION_ECDA_MVP,
  GET_ECDA_EXISTING_PARENT,
  GET_ECDA_EXISTING_CHILD,
  EDIT_REGISTRATION_ECDAMVP,
  CANCEL_ECDA_REGISTRATION,
  REINSTATE_CANCELLED_ECDA_REGISTRATION,
  MERGE_ECDA_REGISTRATION_PARENT_EMAIL,
} from '../models/admissionModel';
import DatadogHandler from '../../utils/datadog';
import { actionHandlerWithFeatureFlag } from '../../utils';
import { FEATURE_FLAGS } from '../../utils/constants';
import {
  msCancelRegistration,
  msCreateRegistration,
  msEditRegistration,
  msFetchExistingChild,
  msFetchExistingParent,
  msFetchRegistrations,
  msFetchRegistrationStates,
  msReinstateCancelledRegistration,
  msCancelEcdaRegistration,
  msCreateRegistrationECDAMVP,
  msFetchECDARegistrations,
  msFetchECDAExistingChild,
  msGetECDAExistingParent,
  msEditRegistrationECDAMVP,
  msMergeEcdaRegistrationParentEmail,
  msReinstateEcdaRegistration,
} from '../../services/RegistrationsService';
import { msFetchExistingParentInfo } from '../../services/UserService';

const fileName = 'src/redux/actions/Admissions.js';

const dispatchFetchAdmissions = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: FETCH_ADMISSIONS,
    key: 'admissions',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchFetchAdmissionsWithFilter = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: FETCH_ADMISSIONS_WITH_FILTER,
    key: 'admissionsWithFilter',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const registrationStatesLoading = () => ({
  type: FETCH_REGISTRATION_STATES,
  key: 'admissionsFilter',
  value: {
    inProgress: true,
  },
});

const registrationStatesSuccess = data => ({
  type: FETCH_REGISTRATION_STATES_SUCCESS,
  key: 'admissionsFilter',
  value: {
    inProgress: false,
    data,
  },
});

const registrationStatesError = error => ({
  type: FETCH_REGISTRATION_STATES_ERROR,
  key: 'admissionsFilter',
  value: {
    inProgress: false,
    data: null,
    error,
  },
});

const dispatchAllRegistrations = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: FETCH_REGISTRATIONS,
    key: 'registrations',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchAllECDARegistrations = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: FETCH_ECDA_REGISTRATIONS,
    key: 'ecdaRegistrations',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchExistingParent = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: FETCH_EXISTING_PARENT,
    key: 'existingParent',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchECDAExistingParent = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: FETCH_ECDA_EXISTING_PARENT,
    key: 'existingParent',
    value: {
      inProgress,
      data,
      error,
    },
  });
};
const dispatchExistingChild = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: FETCH_EXISTING_CHILD,
    key: 'existingChild',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchECDAExistingChild = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: FETCH_ECDA_EXISTING_CHILD,
    key: 'existingChild',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dispatchSuggestedFeeTierForRegistrationChild = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: FETCH_SUGGESTED_FEE_TIER,
    key: 'suggestedFeeTier',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

export const clearExistingChild =
  (inProgress = true, data = null, error = null) =>
  async dispatch => {
    dispatch({
      type: FETCH_EXISTING_CHILD,
      key: 'clearExistingChild',
      value: {
        inProgress,
        data,
        error,
      },
    });
  };

const dispatchSearchChildInAdmissions = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: SEARCH_CHILD_IN_ADMISSIONS,
    key: 'searchChild',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

export const requestAdmissions = async (reqData, dispatch, dispatchFunc) => {
  dispatchFunc(dispatch);

  try {
    const result = await SkApolloRequest({
      params: {
        query: FIND_ALL_ADMISSION,
        variables: reqData,
      },
      type: 'query',
    });

    if (get(result, 'success')) {
      dispatchFunc(dispatch, false, result.data);
    } else {
      dispatchFunc(dispatch, false, null, result.error);
    }
    return result.data;
  } catch (ex) {
    dispatchFunc(dispatch, false, null, { error: ex.message });
    throw ex;
  }
};

export const fetchAdmissions = reqData => async dispatch =>
  requestAdmissions(reqData, dispatch, dispatchFetchAdmissions);

export const fetchAdmissionsWithFilter = reqData => async dispatch =>
  requestAdmissions(reqData, dispatch, dispatchFetchAdmissionsWithFilter);

export const monoFetchRegistrationStates = async dispatch => {
  try {
    const res = await SkApolloRequest({
      params: {
        query: GET_REGISTRATIONS_FRONTEND_STATES,
      },
      type: 'query',
    });

    return res;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoFetchRegistrationStates',
        fileName,
      },
      'error'
    );
    dispatch(registrationStatesError(ex.message));
    return { error: ex?.message };
  }
};

export const fetchRegistrationStates = () => async dispatch => {
  dispatch(registrationStatesLoading());
  try {
    const result = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        dispatch,
        msHandler: msFetchRegistrationStates,
        monoHandler: monoFetchRegistrationStates,
      }
    );
    const data = get(result, 'data.getRegistrationFrontendStates', []);
    dispatch(registrationStatesSuccess(data));
    return data;
  } catch (ex) {
    dispatch(registrationStatesError(ex?.error));
    return ex;
  }
};

export const monoFetchRegistrations = async (_, reqData) => {
  try {
    const data = await SkApolloRequest({
      params: {
        query: GET_REGISTRATIONS,
        variables: reqData,
      },
      type: 'query',
    });
    return data;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoFetchRegistrations',
        fileName,
      },
      'error'
    );
    return {
      success: false,
      error: ex.message,
    };
  }
};

export const fetchRegistrations = reqData => async dispatch => {
  dispatchAllRegistrations(dispatch);
  const data = await actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      dispatch,
      msHandler: msFetchRegistrations,
      monoHandler: monoFetchRegistrations,
      extraData: reqData,
    }
  );

  if (data.success) {
    dispatchAllRegistrations(dispatch, false, data.data);
  } else {
    dispatchAllRegistrations(dispatch, false, null, data.error);
  }
};

export const searchChildInAdmissions = searchVal => async dispatch => {
  dispatchSearchChildInAdmissions(dispatch);
  try {
    const data = await SkApolloRequest({
      params: {
        query: SEARCH_ADMISSIONS,
        variables: {
          q: searchVal,
        },
      },
      type: 'query',
    });
    if (data.success) {
      dispatchSearchChildInAdmissions(dispatch, false, data.data);
    } else {
      dispatchSearchChildInAdmissions(dispatch, false, null, data.error);
    }
  } catch (ex) {
    dispatchSearchChildInAdmissions(dispatch, false, null, {
      error: ex.message,
    });
  }
};

export const monoFetchExistingParent = async (_, nric, email) => {
  const variables = {
    email,
  };
  if (nric) {
    variables.nric = nric;
  }
  try {
    const data = await SkApolloRequest({
      params: {
        query: GET_EXISTING_PARENT,
        variables,
      },
      type: 'query',
    });
    return data;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoFetchExistingParent',
        fileName,
      },
      'error'
    );
    return {
      success: false,
      error: ex.message,
    };
  }
};

export const fetchExistingParent = (nric, email) => async dispatch => {
  dispatchExistingParent(dispatch);
  const resp = await actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      dispatch,
      msHandler: msFetchExistingParent,
      monoHandler: monoFetchExistingParent,
      extraData: { nric, email },
    }
  );
  if (resp.success) {
    dispatchExistingParent(dispatch, false, resp.data);
  } else {
    dispatchExistingParent(dispatch, false, null, resp.error);
  }
  return resp;
};

export const monoGetECDAExistingParent = async (dispatch, { email }) => {
  try {
    const variables = { email };
    const data = await SkApolloRequest({
      params: {
        query: GET_ECDA_EXISTING_PARENT,
        variables,
      },
      type: 'query',
    });
    return data;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoGetECDAExistingParent',
        fileName,
      },
      'error'
    );
    dispatchECDAExistingParent(dispatch, false, null, {
      error: ex.message,
    });
    return { error: ex.message };
  }
};

export const getECDAExistingParent = email => async dispatch => {
  dispatchECDAExistingParent(dispatch);
  try {
    const data = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        dispatch,
        msHandler: msGetECDAExistingParent,
        monoHandler: monoGetECDAExistingParent,
        extraData: { email },
      }
    );
    if (data.success) {
      dispatchECDAExistingParent(dispatch, false, data.data);
    } else {
      dispatchECDAExistingParent(dispatch, false, null, data.error);
    }
    return data;
  } catch (ex) {
    return ex;
  }
};

export const monoFetchExistingParentInfo = async (_, reqData) => {
  try {
    const { parentFilter, childId } = reqData;
    const data = await SkApolloRequest({
      params: {
        query: GET_EXISTING_PARENT_INFO,
        variables: {
          parentFilter,
          childId,
        },
      },
      type: 'query',
    });

    return data;
  } catch (ex) {
    return ex;
  }
};

export const fetchExistingParentInfo =
  (parentFilter, childId) => async dispatch => {
    dispatchExistingChild(dispatch);
    const resp = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        dispatch,
        msHandler: msFetchExistingParentInfo,
        monoHandler: monoFetchExistingParentInfo,
        extraData: { parentFilter, childId },
      }
    );
    return resp;
  };

export const monoFetchExistingChild = async (_, reqData) => {
  try {
    const birthCertificate = get(reqData, 'birthCertificate');
    const dateOfBirth = get(reqData, 'dateOfBirth');

    return SkApolloRequest({
      params: {
        query: GET_EXISTING_CHILD,
        variables: {
          birthCertificate,
          dateOfBirth,
        },
      },
      type: 'query',
    });
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoFetchExistingChild',
        fileName,
      },
      'error'
    );
    return {
      error: ex.message,
    };
  }
};

export const fetchExistingChild =
  (birthCertificate, dateOfBirth) => async dispatch => {
    dispatchExistingChild(dispatch);
    const resp = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        dispatch,
        msHandler: msFetchExistingChild,
        monoHandler: monoFetchExistingChild,
        extraData: { birthCertificate, dateOfBirth },
      }
    );
    if (resp.success) {
      dispatchExistingChild(dispatch, false, resp.data);
    } else {
      dispatchExistingChild(dispatch, false, null, resp.error);
    }
    return resp;
  };

export const monoFetchECDAExistingChild = async (
  dispatch,
  { birthCertificate, dateOfBirth }
) => {
  try {
    const data = await SkApolloRequest({
      params: {
        query: GET_ECDA_EXISTING_CHILD,
        variables: {
          birthCertificate,
          dateOfBirth,
        },
      },
      type: 'query',
    });
    return data;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoFetchECDAExistingChild',
        fileName,
      },
      'error'
    );
    dispatchECDAExistingChild(dispatch, false, null, {
      error: ex.message,
    });
    return {
      error: ex.message,
    };
  }
};

export const fetchECDAExistingChild =
  (birthCertificate, dateOfBirth) => async dispatch => {
    dispatchECDAExistingChild(dispatch);
    try {
      const data = await actionHandlerWithFeatureFlag(
        FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
        {
          msHandler: msFetchECDAExistingChild,
          monoHandler: monoFetchECDAExistingChild,
          extraData: {
            birthCertificate,
            dateOfBirth,
          },
        }
      );
      if (data.success) {
        dispatchECDAExistingChild(dispatch, false, data.data);
      } else {
        dispatchECDAExistingChild(dispatch, false, null, data.error);
      }
      return data;
    } catch (ex) {
      return ex;
    }
  };

export const getSuggestedFeeTierForRegistrationChild =
  reqData => async dispatch => {
    dispatchSuggestedFeeTierForRegistrationChild(dispatch);
    try {
      const data = await SkApolloRequest({
        params: {
          query: SUGGESTED_FEE_TIER,
          variables: reqData,
        },
        type: 'query',
      });
      if (data.success) {
        dispatchSuggestedFeeTierForRegistrationChild(
          dispatch,
          false,
          data.data
        );
      } else {
        dispatchSuggestedFeeTierForRegistrationChild(
          dispatch,
          false,
          null,
          data.error
        );
      }
      return data;
    } catch (ex) {
      dispatchSuggestedFeeTierForRegistrationChild(dispatch, false, null, {
        error: ex.message,
      });
    }
  };

export const monoCreateRegistration = async (_, reqData) => {
  try {
    return SkApolloRequest({
      params: {
        mutation: CREATE_REGISTRATION,
        variables: reqData,
      },
      type: 'mutation',
    });
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoCreateRegistration',
        fileName,
      },
      'error'
    );
    return {
      error: ex.message,
    };
  }
};

export const createRegistration = reqData => async () => {
  return actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      msHandler: msCreateRegistration,
      monoHandler: monoCreateRegistration,
      extraData: reqData,
    }
  );
};

export const monoCreateRegistrationECDAMVP = async (_, reqData) => {
  try {
    return SkApolloRequest({
      params: {
        mutation: CREATE_REGISTRATION_ECDA_MVP,
        variables: reqData,
      },
      type: 'mutation',
    });
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoCreateRegistrationECDAMVP',
        fileName,
      },
      'error'
    );
    return {
      error: ex.message,
    };
  }
};

export const createRegistrationECDAMVP = reqData => async () => {
  return actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      msHandler: msCreateRegistrationECDAMVP,
      monoHandler: monoCreateRegistrationECDAMVP,
      extraData: reqData,
    }
  );
};

export const monoEditRegistration = async (_, reqData) => {
  try {
    return SkApolloRequest({
      params: {
        mutation: EDIT_REGISTRATION,
        variables: reqData,
      },
      type: 'mutation',
    });
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoEditRegistration',
        fileName,
      },
      'error'
    );
    return {
      error: ex.message,
    };
  }
};

export const editRegistration = reqData => async () => {
  return actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      msHandler: msEditRegistration,
      monoHandler: monoEditRegistration,
      extraData: reqData,
    }
  );
};

export const monoEditRegistrationECDAMVP = async (_, reqData) => {
  try {
    return SkApolloRequest({
      params: {
        mutation: EDIT_REGISTRATION_ECDAMVP,
        variables: reqData,
      },
      type: 'mutation',
    });
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoEditRegistrationECDAMVP',
        fileName,
      },
      'error'
    );
    return {
      error: ex.message,
      success: false,
    };
  }
};

export const editRegistrationECDAMVP = reqData => async () => {
  return actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      msHandler: msEditRegistrationECDAMVP,
      monoHandler: monoEditRegistrationECDAMVP,
      extraData: reqData,
    }
  );
};

export const mergerRegistrationParentEmail = reqData => async () => {
  try {
    const data = await SkApolloRequest({
      params: {
        mutation: MERGE_REGISTRATION_PARENT_EMAIL,
        variables: reqData,
      },
      type: 'mutation',
    });
    return data;
  } catch (ex) {
    return ex;
  }
};

export const mergeParentAccount = reqData => async () => {
  try {
    const data = await SkApolloRequest({
      params: {
        mutation: MERGE_PARENT_ACCOUNT,
        variables: reqData,
      },
      type: 'mutation',
    });
    return data;
  } catch (ex) {
    return ex;
  }
};

export const monoCancelRegistration = async (_, reqData) => {
  try {
    return SkApolloRequest({
      params: {
        mutation: CANCEL_REGISTRATION,
        variables: reqData,
      },
      type: 'mutation',
    });
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoCancelRegistration',
        fileName,
      },
      'error'
    );
    return {
      error: ex.message,
    };
  }
};

export const cancelRegistration = reqData => async () => {
  return actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      msHandler: msCancelRegistration,
      monoHandler: monoCancelRegistration,
      extraData: reqData,
    }
  );
};

export const monoReinstateCancelledRegistration = async (_, reqData) => {
  try {
    const { registrationID, remarks } = reqData;
    return SkApolloRequest({
      params: {
        mutation: REINSTATE_CANCELLED_REGISTRATION,
        variables: { registrationID, remarks },
      },
      type: 'mutation',
    });
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoReinstateCancelledRegistration',
        fileName,
      },
      'error'
    );
    return {
      error: ex.message,
    };
  }
};

export const reinstateCancelledRegistration =
  (registrationID, remarks) => async () => {
    return actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        msHandler: msReinstateCancelledRegistration,
        monoHandler: monoReinstateCancelledRegistration,
        extraData: { registrationID, remarks },
      }
    );
  };

export const monoFetchECDARegistrations = async (_, reqData) => {
  try {
    return SkApolloRequest({
      params: {
        query: GET_ECDA_REGISTRATIONS,
        variables: reqData,
      },
      type: 'query',
    });
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoFetchECDARegistrations',
        fileName,
      },
      'error'
    );
    return {
      error: ex.message,
    };
  }
};

export const fetchECDARegistrations = reqData => async dispatch => {
  dispatchAllECDARegistrations(dispatch);
  const resp = await actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      dispatch,
      msHandler: msFetchECDARegistrations,
      monoHandler: monoFetchECDARegistrations,
      extraData: reqData,
    }
  );
  if (resp.success) {
    dispatchAllECDARegistrations(dispatch, false, resp.data);
  } else {
    dispatchAllECDARegistrations(dispatch, false, null, resp.error);
  }
  return resp;
};

export const monoCancelEcdaRegistration = async (_, reqData) => {
  try {
    return SkApolloRequest({
      params: {
        mutation: CANCEL_ECDA_REGISTRATION,
        variables: reqData,
      },
      type: 'mutation',
    });
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoCancelEcdaRegistration',
        fileName,
      },
      'error'
    );
    return {
      error: ex.message,
    };
  }
};

export const cancelEcdaRegistration = async reqData => {
  return actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      msHandler: msCancelEcdaRegistration,
      monoHandler: monoCancelEcdaRegistration,
      extraData: reqData,
    }
  );
};

export const monoReinstateEcdaRegistration = async (_, reqData) => {
  try {
    const data = await SkApolloRequest({
      params: {
        mutation: REINSTATE_CANCELLED_ECDA_REGISTRATION,
        variables: reqData,
      },
      type: 'mutation',
    });
    return data;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoReinstateEcdaRegistration',
        fileName,
      },
      'error'
    );
    return {
      error: ex.message,
    };
  }
};

export const reinstateEcdaRegistration = async reqData => {
  return actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      msHandler: msReinstateEcdaRegistration,
      monoHandler: monoReinstateEcdaRegistration,
      extraData: reqData,
    }
  );
};

const monoMergeEcdaRegistrationParentEmail = async (_, reqData) => {
  try {
    const data = await SkApolloRequest({
      params: {
        mutation: MERGE_ECDA_REGISTRATION_PARENT_EMAIL,
        variables: reqData,
      },
      type: 'mutation',
    });
    return data;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        fileName,
        functionName: 'monoMergeEcdaRegistrationParentEmail',
      },
      'error'
    );
    return ex;
  }
};

export const mergerEcdaRegistrationParentEmail = reqData => async () => {
  return actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      msHandler: msMergeEcdaRegistrationParentEmail,
      monoHandler: monoMergeEcdaRegistrationParentEmail,
      extraData: reqData,
    }
  );
};

export default fetchAdmissions;
